var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M3 7.71875H15.8199C18.0953 7.71875 19.94 9.50961 19.94 11.7188C19.94 13.9279 18.0953 15.7188 15.8199 15.7188H15V12.7188L11 16.7188L15 20.7187V17.7188H15.8199C19.2331 17.7188 22 15.0325 22 11.7188C22 8.40504 19.2331 5.71875 15.8199 5.71875H3V7.71875ZM3 15.7188H9V17.7188H3V15.7188Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 24 25"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
